/**
 * API 端點定義
 * 集中管理所有 API 端點
 */

export const endpoints = {
  auth: {
    googleLogin: "/v1/auth/google",
    googleOneTapLogin: "/v1/auth/google/one-tap",
    googleOauth: "/v1/auth/google/oauth",
    logout: "/v1/auth/logout",
  },
  users: {
    me: "/v1/users/me",
    // 獲取用戶當前上下文（專案和頁面）
    context: `/v1/user-context`,
    // 設置用戶當前上下文
    setContext: `/v1/user-context/set`,
  },
  projects: {
    list: "/v1/projects",
    detail: (projectId: string) => `/v1/projects/${projectId}`,
  },
  pages: {
    list: (projectId: string) => `/v1/projects/${projectId}/pages`,
    detail: (projectId: string, pageId: string) =>
      `/v1/projects/${projectId}/pages/${pageId}`,
    preview: (projectId: string, pageId: string) =>
      `/v1/projects/${projectId}/pages/${pageId}/preview`,
    prebuild: (projectId: string, pageId: string) =>
      `/v1/projects/${projectId}/pages/${pageId}/prebuild`,
    publish: (projectId: string, pageId: string) =>
      `/v1/projects/${projectId}/pages/${pageId}/publish`,

    // // 頁面版本相關
    // versions: {
    //   list: (pageId: string) => `/pages/${pageId}/versions`,
    //   detail: (pageId: string, versionId: string) =>
    //     `/pages/${pageId}/versions/${versionId}`,
    //   create: (pageId: string) => `/pages/${pageId}/versions`,
    //   apply: (pageId: string, versionId: string) =>
    //     `/pages/${pageId}/versions/${versionId}/apply`,
    // },
  },
  chat: {
    // 聊天訊息相關端點 - 頁面級
    pageMessages: (sessionId: string) =>
      `/v1/pages/conversations/${sessionId}/messages`,
    files: (sessionId: string) => `/v1/pages/conversations/${sessionId}/files`,
  },
};
